import { render, staticRenderFns } from "./deletePayFeeConfigDiscount.vue?vue&type=template&id=322975be"
import script from "./deletePayFeeConfigDiscount.vue?vue&type=script&lang=js"
export * from "./deletePayFeeConfigDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports